import React, { useCallback, useEffect, useState } from "react";
import LoadingEffect from "../../components/LoadingEffect";
import { Button, OperationButton } from "../../styles-components/Buttons";
import { Container } from "../../styles-components/Container";
import {
  Column,
  ErrorMessage,
  Form,
  FormHeader,
  Label,
  Row,
  RowOption,
  RowValueButtons,
} from "../../styles-components/FormItens";

import { useForm } from "react-hook-form";
import inputFormat from "../../utils/inputFormat";
import { format, parseISO } from "date-fns";
import { toast } from "react-toastify";
import { apiLanches } from "../../services/data";
import DateVerifySnack from "../../utils/DateVerifySnack";
import UseRedirectView from "../../utils/UseRedirectView";
import ToggleSwitch from "../../components/ToggleSwitch";

const FormLanches = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isSmallView, setIsSmallView] = useState(false);
  const [isShowTime, setIsShowtime] = useState(false);
  const [isShowDate, setIsShowDate] = useState(false);
  const [typeService, setTypeService] = useState("");
  const [dataApi, setDataApi] = useState({});

  const {
    register,
    watch,
    formState: { errors },
    formState,
    handleSubmit,
    setValue,
    getValues,
    setError,
    clearErrors,
    unregister,
  } = useForm();

  const watchDate = watch("date");
  const watchService = watch("type_service");
  const watchTime = watch("time");
  const watchGlass = watch("glass");

  useEffect(() => {
    fetchData();
    if (window.innerWidth <= 570) {
      setIsSmallView(true);
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (watchDate !== "" && watchDate !== undefined) {
      if (watchTime || errors.time) {
        clearErrors("time");
        setValue("time", "");
      }
      setIsShowtime(true);
    }
  }, [watchDate]);

  useEffect(() => {
    if (watchService !== "" && watchService !== undefined) {
      if (watchTime !== "" && watchTime !== undefined) {
        if (errors.time) {
          clearErrors("time");
        }
        setValue("time", "");
      }
      setIsShowDate(true);
      dataApi.snacks.map((snack) => {
        if (snack.id == watchService) {
          if (snack.nome.toUpperCase().search("COFFEE") === 0) {
            setTypeService("coffee");
          } else if (snack.nome.toUpperCase().search("REFRIGERANTE") === 0) {
            setTypeService("soda");
            unregister(["glass", "tablecloth"]);
          } else {
            setTypeService("snack");
            unregister(["glass", "tablecloth"]);
          }
        }
      });
    }
  }, [watchService]);

  useEffect(() => {
    if (watchTime !== "" && watchTime !== undefined) {
      if (dataApi.is_nutritionist === false) {
        if (typeService === "snack") {
          clearErrors("time");
          var validation = DateVerifySnack.handleVerify(
            new Date(),
            new Date(parseISO(watchDate)),
            watchTime,
            typeService
          );

          if (validation.error) {
            setError("time", { message: validation.message });
          }
        } else if (typeService === "soda") {
          clearErrors("time");
          var validation = DateVerifySnack.handleVerify(
            new Date(),
            new Date(parseISO(watchDate)),
            watchTime,
            typeService
          );

          if (validation.error) {
            setError("time", { message: validation.message });
          }
        } else {
          clearErrors("time");
          var validation = DateVerifySnack.handleVerify(
            new Date(),
            new Date(parseISO(watchDate)),
            watchTime,
            typeService
          );
          if (validation.error) {
            setError("time", { message: validation.message });
          }
        }
      }
    }
  }, [watchTime]);

  useEffect(() => {
    if (watchGlass !== "" && watchGlass !== undefined) {
      clearErrors("glass");
      if (watchGlass) {
        setError("glass", {
          message: "Está opção causa acréscimo de valor na solicitação",
        });
      }
    }
  }, [watchGlass]);

  const fetchData = async () => {
    await apiLanches.index().then((response) => {
      response.data.data.snacks.sort(function (a, b) {
        return a.nome > b.nome ? 1 : b.nome > a.nome ? -1 : 0;
      });
      response.data.data.clients.sort(function (a, b) {
        return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
      });
      setDataApi({ ...response.data.data });
    });
  };

  const onSubmit = useCallback(
    async (data) => {
      try {
        await apiLanches.store(data);
        toast.success("Lanche cadastrado com sucesso!");
        dataApi["is_nutritionist"]
          ? UseRedirectView.to("nutri/pedidos/listagem")
          : UseRedirectView.to("pedidos/listagem");
      } catch (error) {
        toast.error("Algo deu errado ao inserir!");
      }
    },
    [history, dataApi]
  );

  const handleSetValueButton = useCallback(
    (operator) => {
      switch (operator) {
        case "+":
          setValue("quantity", parseInt(getValues("quantity")) + 1, {
            shouldValidate: true,
          });
          break;

        case "-":
          setValue("quantity", parseInt(getValues("quantity")) - 1, {
            shouldValidate: true,
          });
          break;
      }
    },
    [setValue, getValues]
  );

  return (
    <>
      {isLoading ? (
        <LoadingEffect />
      ) : (
        <Container>
          <FormHeader>
            <h1>Solicitar lanche</h1>
            <Button
              color="--white"
              backgroundColor="--orange"
              onClick={() => {
                if (dataApi["has_role_nutricionista"]) {
                  return UseRedirectView.to("nutri/pedidos/listagem");
                }
                return UseRedirectView.to("pedidos/listagem");
              }}
            >
              Voltar
            </Button>
          </FormHeader>
          <Form method="POST" onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Label>Cliente:</Label>
              <select
                {...register("client", {
                  required: { value: true, message: "Selecione um cliente" },
                })}
                style={errors.client && { ...inputFormat }}
              >
                <option></option>
                {dataApi.clients?.map((client) => (
                  <option key={client.id} value={client.id}>
                    {client.name}
                  </option>
                ))}
              </select>
            </Row>
            {errors.client && (
              <ErrorMessage color="--red">{errors.client.message}</ErrorMessage>
            )}
            <Row>
              <Label htmlFor="type_service">Tipo:</Label>
              <select
                {...register("type_service", {
                  required: { value: true, message: "Selecione o tipo" },
                })}
                style={errors.type_service && { ...inputFormat }}
              >
                <option></option>
                {dataApi.snacks?.map((snack) => (
                  <option key={snack.id} value={snack.id}>
                    {snack.nome}
                  </option>
                ))}
              </select>
            </Row>
            {errors.type_service && (
              <ErrorMessage color="--red">
                {errors.type_service.message}
              </ErrorMessage>
            )}
            <Row>
              <Label htmlFor="place">Local:</Label>
              <input
                type="text"
                {...register("place", {
                  required: { value: true, message: "Informe um lugar" },
                })}
                style={errors.place && { ...inputFormat }}
                id="place"
              />
            </Row>
            {errors.place && (
              <ErrorMessage color="--red">{errors.place.message}</ErrorMessage>
            )}
            {isShowDate && (
              <Row>
                <Label htmlFor="date">Data:</Label>
                <input
                  type="date"
                  // min={format(new Date(), "yyyy-MM-dd")}
                  {...register("date", {
                    required: { value: true, message: "Informe uma data" },
                  })}
                  style={errors.date && { ...inputFormat }}
                  id="date"
                />
              </Row>
            )}
            {errors.date && (
              <ErrorMessage color="--red">{errors.date.message}</ErrorMessage>
            )}
            {isShowTime && (
              <Row>
                <Label htmlFor="time">Horário:</Label>
                <input
                  type="time"
                  step="any"
                  {...register("time", {
                    required: { value: true, message: "Informe o horário" },
                  })}
                  style={errors.time && { ...inputFormat }}
                  id="time"
                />
              </Row>
            )}
            {errors.time && (
              <ErrorMessage color="--red">{errors.time.message}</ErrorMessage>
            )}
            <Row>
              <Label>Quantidade: </Label>
              {!isSmallView ? (
                <input
                  type="number"
                  {...register("quantity", {
                    required: {
                      value: true,
                      message: "Informe uma quantidade",
                    },
                    min: {
                      value: 1,
                      message: "Informe uma quantidade maior que 0",
                    },
                  })}
                  style={errors.quantity && { ...inputFormat }}
                  id="quantity"
                />
              ) : (
                <RowValueButtons>
                  <OperationButton
                    type="button"
                    onClick={() => handleSetValueButton("-")}
                  >
                    -
                  </OperationButton>
                  <input
                    type="number"
                    min="1"
                    {...register("quantity", { required: true, value: 0 })}
                    style={errors.quantity && { ...inputFormat }}
                    id="quantity"
                  />
                  <OperationButton
                    type="button"
                    onClick={() => handleSetValueButton("+")}
                  >
                    +
                  </OperationButton>
                </RowValueButtons>
              )}
            </Row>
            {errors.quantity && (
              <ErrorMessage color="--red">
                {errors.quantity.message}
              </ErrorMessage>
            )}
            {[30, 31, 32, 33, 57, 58, 59, 60, 61, 62, 72].find(
              (id) => id == watchService
            ) !== undefined && (
              <>
                <RowOption>
                  <ToggleSwitch register={register} name={"tablecloth"} />
                  <Label>Solicitar toalha de mesa</Label>
                </RowOption>
                <RowOption>
                  <ToggleSwitch register={register} name={"glass"} />
                  <Label>Solicitar copo de vidro</Label>
                </RowOption>
                {errors.glass && (
                  <ErrorMessage color="--red">
                    {errors.glass.message}
                  </ErrorMessage>
                )}
              </>
            )}
            <Column>
              <Label>Observação: </Label>
              <textarea
                {...register("note", {
                  required: {
                    value: true,
                    message: "Preencha com alguma observação",
                  },
                })}
                style={errors.note && { ...inputFormat }}
                id="note"
                cols="10"
              ></textarea>
            </Column>
            {errors.note && (
              <ErrorMessage color="--red">{errors.note.message}</ErrorMessage>
            )}
            {!errors.time && (
              <Button
                color="--white"
                backgroundColor="--orange"
                align="flex-end"
              >
                Criar
              </Button>
            )}
          </Form>
        </Container>
      )}
    </>
  );
};

export default FormLanches;
